export default "__VITE_ASSET__CaDl0N00__"